<template>
  <div class="date-group">
    <p class="filter-tit">
      {{ fieldname }}
    </p>

    <cube-checkbox
      v-if="data.fieldkey === 'next_followup_time'"
      :value="isDelay"
      shape="square"
      @input="handleCheckboxNextFollowupTime"
    >
      {{ $t('message["103"]') }}
    </cube-checkbox>
    <cube-checkbox-group
      v-if="data.fieldkey === 'followup_remind_time' && data.options"
      v-model="period"
      class="follow-checkbox-group"
      :options="data.options"
      shape="square"
      @input="remindTimeCheckboxHandle"
    />
    <div
      class="item start-time border-bottom-1px"
      @click="showPicker1"
    >
      <span :class="['left', {'fs-black': dateTime.starttime}]">
        <i class="icon iconfont icon-calendar iconicon-test31" />
        {{ dateTime.starttime || $t('message["563"]') }}
      </span>
      <i class="iconfont icon-angle-right iconicon-test18" />
    </div>
    <div
      class="item end-time border-bottom-1px"
      @click="showPicker2"
    >
      <span :class="['left', {'fs-black': dateTime.endtime}]">
        <i class="icon iconfont icon-calendar iconicon-test26" />
        {{ dateTime.endtime || $t('message["512"]') }}
      </span>
      <i class="icon iconfont icon-angle-right iconicon-test18" />
    </div>
  </div>
</template>

<script>
const year = (new Date()).getFullYear()

export default {
  props: {
    data: {
      type: [Object, Array, String, Boolean],
      default () {
        return {}
      }
    },
    value: {
      type: Object,
      default: () => ({})
    },
    min: {
      type: Date,
      default: () => new Date(year - 10, 0, 1)
    },
    max: {
      type: Date,
      default: () => new Date(year + 10, 11, 31)
    }
  },
  data () {
    return {
      format: {
        month: 'MM',
        date: 'DD'
      },
      dateTime: this.value || { starttime: '', endtime: '' },
      isDelay: false,
      period: []
    }
  },
  computed: {
    fieldname () {
      return this.data.fieldname
    }
  },
  created () {
    this.picker1 = this.$createDatePicker({
      title: this.$t('message["563"]'),
      min: this.min,
      // max: this.max,
      value: new Date(),
      format: this.format,
      onSelect: this.selectHandle1,
      onCancel: this.cancelHandle1
    })
    this.picker2 = this.$createDatePicker({
      title: this.$t('message["512"]'),
      // min: this.min,
      max: this.max,
      value: new Date(),
      format: this.format,
      onSelect: this.selectHandle2,
      onCancel: this.cancelHandle2
    })

    if (this.data.fieldkey === 'next_followup_time') {
      this.data.options = [{
        id: this.data.fieldconfig.fieldkey,
        name: this.$t('message["103"]')
      }]
      this.isDelay = this.value.is_dely === 1
    }

    if (this.data.fieldkey === 'followup_remind_time') {
      this.data.options = this.data.options.map(item => {
        return {
          label: item.name,
          value: item.id
        }
      })
      this.period = this.value.period || []
      // this.$set(this.value, 'period', this.value.period || [])
    }
  },
  methods: {
    showPicker1 () {
      this.picker1.show()
    },
    showPicker2 () {
      this.picker2.show()
    },
    selectHandle1 (date, selectedVal, selectedText) {
      this.picker2.$updateProps({
        min: date
      })
      this.dateTime.starttime = selectedVal.join('-')
      this.value.starttime = this.dateTime.starttime

      let obj = this.setObj()
      this.$emit('change', obj)
    },
    cancelHandle1 () {
      //
    },
    selectHandle2 (date, selectedVal, selectedText) {
      this.dateTime.endtime = selectedVal.join('-')
      this.value.endtime = this.dateTime.endtime
      this.picker1.$updateProps({
        max: date
      })

      let obj = this.setObj()
      this.$emit('change', obj)
    },
    cancelHandle2 () {
      //
    },
    handleCheckboxNextFollowupTime (checked) {
      this.isDelay = checked

      let obj = this.setObj()
      this.$emit('change', obj)
    },
    remindTimeCheckboxHandle (checked) {
      this.period = checked
      let obj = this.setObj()
      this.$emit('change', obj)
    },
    setObj () {
      let obj = {
        starttime: this.value.starttime || '',
        endtime: this.value.endtime || ''
      }
      if (this.data && this.data.fieldkey === 'next_followup_time' && this.data.fieldconfig && this.data.fieldconfig.fieldkey) {
        obj[this.data.fieldconfig.fieldkey] = this.isDelay ? 1 : 0
      }
      if (this.data && this.data.fieldkey === 'followup_remind_time') {
        obj.period = this.period
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
.date-group::v-deep {
  .item {
    display: flex;
    justify-content: space-between;
    height: 56px;
    line-height: 56px;
    padding: 0 16px;
    color: #b3b3b3;
    font-size: 16px;
    .icon-calendar {
      color: #d6d6d6;
    }
    .icon-angle-right {
      color: #d6d6d6;
    }
  }
  .icon-calendar {
    margin-right: 5px;
  }
  .border-bottom-1px:after {
    transform-origin: 20px bottom;
  }
  .follow-checkbox-group {
    &::before {
      border-top: none;
    }
    &::after {
      border-bottom: none;
    }
    .cube-checkbox {
      display: inline-block;
    }
    background: none;
    .cube-checkbox-wrap {
      padding-bottom: 0;
      &:after {
        border-bottom: none;
      }
    }
  }
}
</style>
